<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 1H3a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1V4.5L6.5 1z"
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M6.5 1v3.5H10" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: 'FileIcon',
};
</script>
